<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        class="mb-4"
        :src="require('@/assets/logo-white.svg')"
        contain
        max-width="300"
        width="100%"
      />

      <base-body>
        Manufacturing quality Propshafts since 1996
      </base-body>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: 'BaseInfo',

  props: {
    title: String,
    dark: Boolean,
  },
};
</script>
